export default __webpack_public_path__ + "static/media/Iron Condor.ceae0929.svg";